import { IPage } from '@/types/AppTypes';
import { httpRequest } from '@/utils/HttpRequest';
import { IWcdDetail, IWcdSearch, IWarningInsert } from './wcdTypes';

class WcdService {
	async page(searchVo: IWcdSearch, config: object = {}) {
		const apiUrl = '/gtm/warning/customs/listPage';
		return await httpRequest.post<IPage<IWcdDetail>>(apiUrl, searchVo, config);
	}
	//导出
	async export(searchVo: IWcdSearch) {
		const appPageUrl = '/gtm/warning/customs/export';
		return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
	}
	// 预警设置
	async warning(insertVo:IWarningInsert[]) {
        const apiUrl = '/gtm/warning/insertOrUpdate';
		return await httpRequest.post<boolean>(apiUrl, insertVo);
    }

    // 获取预警设置
    async select(type?:string) {
        const apiUrl = `/gtm/warning/select/${type}`;
		return await httpRequest.get<IWarningInsert[]>(apiUrl);
    }

	// 获取全部
	async allList() {
		const apiUrl = '/gtm/warning/list';
		return await httpRequest.post<IWarningInsert[]>(apiUrl);
	}
}

export const wcdService = new WcdService();
